'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

/**
 * 时间选择器
 */
var TimePicker2 = React.createClass({
  render: function () {
    return (<img className="component-SimpleCom"
                 src={assetsHelper.getComponentAsset('TimePicker2')}
    />);
  }
});

module.exports = TimePicker2;


// WEBPACK FOOTER //
// ./src/views/Components/TimePicker2.jsx